import { useEffect } from "react";
import { ErrorLoggingV2 } from "src/utils/errorHelpers";
import { getAnalytics } from "src/pages/helpers";
import { getInhouseAnonymousIdFromCookie } from "src/utils/anonymousId";
import { getStoredInhouseAnonymousId } from "src/services/analyticsInit";
export const usePageTracking = () => {
  useEffect(() => {
    const trackingFunction = async (isWaiting = false, attempt = 0) => {
      const analytics = await getAnalytics();
      if (analytics) {
        const inhouseId = getStoredInhouseAnonymousId() || getInhouseAnonymousIdFromCookie();
        analytics?.page(window.location.pathname, {
          url: window.location.href,
          title: document.title,
          referrer: document.referrer,
          queryParams: window.location.search,
          inhouse_anonymous_id: inhouseId,
        });
        if (isWaiting) {
          analytics?.track("analytics_initialized", {
            url: window.location.href,
            title: document.title,
            referrer: document.referrer,
            queryParams: window.location.search,
            attempt: attempt,
          });
        }
      } else {
        if (attempt === 3) {
          ErrorLoggingV2("Analytics_not_initialized", {
            url: window.location.href,
            title: document.title,
            referrer: document.referrer,
            queryParams: window.location.search,
            attempt: attempt,
            user_id: localStorage.getItem("ajs_user_id") || getInhouseAnonymousIdFromCookie(),
          });
        }
        // console.error("Analytics not initialized");
        if (attempt >= 3) {
          return;
        }
        setTimeout(() => {
          trackingFunction(true, attempt + 1);
        }, 3000);
      }
    };
    setTimeout(() => {
      trackingFunction();
    }, 3000);
  }, []);
};

export default usePageTracking;
